
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 70 70"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(23 23)"}},[_c('rect',{attrs:{"x":"10","width":"4","height":"24","rx":"3"}}),_c('rect',{attrs:{"y":"10","width":"24","height":"4","rx":"3"}})])])
          )
        }
      }
    